import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-page',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
